import { AxiosResponse } from 'axios';
import { reportType } from '../../../infrastructure/constants/reportType';
import actions from '../../../store/actions';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import DataSourceForm from '../DataSources/DataSourceForm';
import ErrorMessage from '../../Common/ErrorMessage/ErrorMessage';
import history from '../../../infrastructure/helpers/react/history';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import IngestionConfigOption from '../../../types/ingestion/IngestionConfigOption';
import PromiseButton from '../../Common/PromiseButton';
import React from 'react';
import ReportConfig from '../../../types/report/ReportConfig';
import reportPageMode from './ReportPage/ReportPageMode';
import store from '../../../store/store';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import {  getEmptyReportConfig } from './ReportPage/ReportPage.Helpers';
import dataSourceValidators from '../DataSources/DataSourceForm.Validation';

interface State {
    isWaiting: boolean;
    error: string | null;
    reportConfig: ReportConfig;
}

class GlobalModuleDataSourcePage extends React.Component<any, State>  {
    private dataSourceOptions: IngestionConfigOption[];
    private fieldIds: number[];

    constructor(props: any) {
        super(props);

        this.dataSourceOptions = [];
        this.fieldIds = [];

        this.state = {
            isWaiting: true,
            error: null,
            reportConfig: getEmptyReportConfig()
        };

        this.onGetDataSourceOptionsSuccess = this.onGetDataSourceOptionsSuccess.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
    }

    componentDidMount(): void {
        this.getDataSourceOptions().then(this.onGetDataSourceOptionsSuccess);
    }

    getDataSourceOptions() {

        let route = urlHelper.buildRoute(['ingestion', 'enabled', 'CompletenessFieldLevelMatching']);

        return httpClient.get<IngestionConfigOption[]>(route);
    }

    onGetDataSourceOptionsSuccess(response: AxiosResponse<IngestionConfigOption[]>): void {

        response.data.forEach(x => this.dataSourceOptions.push(x));

        this.setState({ isWaiting: false, reportConfig:getEmptyReportConfig() });
    }

    onChange(reportConfig: ReportConfig): void {

        store.dispatch({ type: actions.navigation.setUnsafe, payload: null as any });

        let config = Object.assign({}, this.state.reportConfig, reportConfig);

        this.setState({ reportConfig:config });
    }

    onSaveClick(): Promise<any> {
        let error = dataSourceValidators.validateGlobalModuleConfigDataSources(this.state.reportConfig);

        this.setState({ error });

        if (error) {
            return Promise.reject(error);
        }

        let copy = copyObject(this.state.reportConfig);

        return httpClient.post('report/global-module', copy).then(this.onSaveSuccess);
    }

    onSaveSuccess(): void {
        store.dispatch({ type: actions.navigation.execute, payload: () => history.push(appRoutes.global.home) });
    }

    render(): JSX.Element {
        return (
            <>
                <div className="row">
                    <div className="col-12 col-sm-11 col-md-10">
                        <DataSourceForm
                            isWaiting={this.state.isWaiting}
                            dataSources={this.dataSourceOptions}
                            reportConfig={this.state.reportConfig}
                            onChange={this.onChange}
                            mode={reportPageMode.create}
                            collections={this.props.collections}
                            hideReferences={true}
                            reportType={reportType.globalModule}
                        />
                    </div>
                </div>

                <ErrorMessage error={this.state.error} />

                <div className="mt-3 mb-3">
                    <PromiseButton text="Save" className="btn cb-btn" enableOnErrorOnly={true} task={this.onSaveClick} />
                </div>
            </>
        );
    }
}

export default GlobalModuleDataSourcePage;
